module.exports = __webpack_public_path__ + "media/images/logos/logo-glin-primary-30f376f5dcafe6ac77a34052af2a9dd9.svg";